<template>
    <v-overlay :value="$store.state.loader">
        <v-progress-circular 
                indeterminate 
                size="64" 
                color="primary"
                width="7"
        ></v-progress-circular>
        <h3 :style="{color: $vuetify.theme.themes[theme].background}">Loading</h3>
    </v-overlay>
</template>


<script>
    export default {
        name: "Loader",
        computed: {
            theme(){
                return (this.$vuetify.theme.dark) ? 'dark' : 'light'
            }
        },
    }
</script>
